import React, { useState } from 'react';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import StudentDetailsViewMore from '../studentDetailsViewMore/StudentDetailsViewMore';

const StudentInformation = () => {
  const [viewMoreDialog, setViewMoreDialog] = useState(false);
  const handleViewMore = () => {
    setViewMoreDialog(true);
  };
  return (
    <>
      <MDBox pt={1}></MDBox>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <MDTypography variant='h6'>Course Information</MDTypography>
        <Button variant='text' onClick={handleViewMore}>
          View More
        </Button>
      </Box>
      <StudentDetailsViewMore
        open={viewMoreDialog}
        setOpen={setViewMoreDialog}
      />
    </>
  );
};

export default StudentInformation;
